import React from 'react';
import { motion } from 'framer-motion';
import { EyeOff } from 'lucide-react';
export function PainValidation() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-96" data-mp="187aqq6xxuqx1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-97" data-mp="u6q7xas0wv3j">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-98" data-mp="u8b04tqv81y8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-stone-100 text-stone-600 text-[10px] md:text-xs font-bold tracking-wide uppercase mb-4 md:mb-6" data-id="element-99" data-mp="1qwhcy3xxy0nl">
            <EyeOff className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-100" data-mp="1i3nk13pkn2r9" />
            El estrés silencioso
          </div>

          <p className="font-display text-xl md:text-4xl font-extrabold text-gray-900 tracking-tight leading-snug mb-4 md:mb-6" data-id="element-101" data-mp="25thvphy5ml9x">
            Trabajar duro y no saber en qué se va tu dinero es una forma de
            estrés silencioso.
          </p>

          <p className="text-sm md:text-xl text-gray-600 leading-relaxed" data-id="element-102" data-mp="3fp7pejh73cvk">
            La frustración no es por falta de dinero, es por{' '}
            <span className="font-bold text-teal-700" data-id="element-103" data-mp="3the92fjk41zr">falta de vista</span>. No
            necesitas ganar más para ordenar tu vida: necesitas ver la verdad de
            tus números para tomar mejores decisiones.
          </p>
        </motion.div>
      </div>
    </section>;
}